import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined"
import { styled } from "@mui/material/styles"

export default styled(AutoAwesomeOutlinedIcon)(() => ({
  fill: "#FFD700",
}))
